export const DataHooks = {
  Root: 'AddModal.Root',
  SubmitButton: 'AddModal.SubmitButton',
  CloseButton: 'AddModal.CloseButton',
} as const;
